import DOMPurify from "dompurify";

/**
 * Xss Filter
 * @param input
 * @returns {boolean}
 */
export const containsXss = (input) => {
    const sanitizedInput = DOMPurify.sanitize(input);
    return input !== sanitizedInput;
}